import React, { createContext, useContext } from 'react';

type RewindContextType = {
  flashbackType?: number;
  screenName?: ScreenNames;
  trackingScreenName?: string;
};

const RewindContext = createContext<RewindContextType>({});

export const useRewindContext = () => useContext(RewindContext);

type RewindProviderProps = {
  flashbackType?: number;
  screenName?: ScreenNames;
  trackingScreenName?: string;
  children: React.ReactNode;
};

export const RewindProvider = ({
  flashbackType,
  screenName,
  trackingScreenName,
  children
}: RewindProviderProps) => {
  return (
    <RewindContext.Provider
      value={{ flashbackType, screenName, trackingScreenName }}
    >
      {children}
    </RewindContext.Provider>
  );
};
